module.exports = __webpack_public_path__ + "static/media/Pickford-Meadows-Northville.b6238e97.pdf";